// Output modes:
////////////////////////////////////////////////////////////////

// Each output mode gets its own closure,
// distinct from the validity closure.

// Install the tooltip output.
(function($) {
    //var fieldsWithErrorsAtStart = [];
    //var fieldErrosRaised = [];

    $.validity.outputs.rowhire = {

        errorIcon: '<svg class="icon icon-status icon-error" focusable="false"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/images/icons.svg#streamplus-report-problem-circle"></use></svg>',
        successIcon: '<svg class="icon icon-status icon-success" focusable="false"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/images/icons.svg#streamplus-check-circle-2"></use></svg>',

        rowErrorClass: 'row-has-errors',
        rowSuccessClass: 'row-is-valid',

        // The start function will be called when validation starts.
        // This allows you to prepare the page for validation, for instance
        // you might remove any validation messages that are already on the page.
        start:function() { },

        // The end function is called when validation has concluded.
        // This allows you to flush any buffers or do anything you need to
        // after all of the validators have been called.
        // results will be the results object.
        // results.valid is a boolean representing whether the form is valid.
        // results.errors is an integer of how many errors there are.
        end:function(results) {
            // If not valid and scrollTo is enabled, scroll the page to the first error.
            if (!results.valid && $.validity.settings.scrollTo) {
                $(document).scrollTop(
                    $("." + $.validity.outputs.tooltip.tooltipClass)
                        .offset()
                        .top
                );
            }
        },

        // The raise function is called to raise an error for a specific input.
        // The first argument is a jQuery object of the input to raise the error message for.
        // The second argument is the string of the error message.
        raise:function($obj, msg) {

            var $row = $obj.parents('.row');

            $('.icon-status', $row).remove();

            $row.removeClass($.validity.outputs.rowhire.rowSuccessClass)
                .addClass($.validity.outputs.rowhire.rowErrorClass)
                .append($($.validity.outputs.rowhire.errorIcon))
            ;
        },

        // The raiseAggregate function is similar to the raise function, except that
        // the $obj argument will be a jQuery object of several inputs,
        // all of which are invalid aggregately.
        raiseAggregate:function($obj, msg) {
            // Just raise the error on the last input.
            if ($obj.length) {
                this.raise($obj.filter(":last"), msg);
            }
        },

        success:function($obj) {
            "use strict";

            var $row = $obj.parents('.row');

            $('.icon-status', $row).remove();

            $row.removeClass($.validity.outputs.rowhire.rowErrorClass)
                .addClass($.validity.outputs.rowhire.rowSuccessClass)
                .append($($.validity.outputs.rowhire.successIcon))
            ;

        },

        successAggregate:function($obj) {
            "use strict";

            if ($obj.length) {
                this.success($obj.filter(":last"), msg);
            }
        }
    };
})(jQuery);
